import config from "config/config";
import { getToken } from "js/formatting/getToken";

const getChatManualFlag = async (portalType) => {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
      Authorization: `bearer ${getToken()}`,
    },
  };

  const response = await fetch(
    `${config.REG_API_BASE_URL}/Chat/manualflag?portal=${portalType}`,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
};

export default getChatManualFlag;
